import { Badge } from '@mui/material';
import Tooltip from '../../../../../../../common/tooltip';
import { nortadaLogger } from '../../../../../../../common/logger';
import { OPERATION_DETAILS_EVENT_TYPE } from '../interfaces';

interface Props {
  type: OPERATION_DETAILS_EVENT_TYPE;
}
const StatusIcon = ({ type }: Props) => {
  switch (type) {
    case OPERATION_DETAILS_EVENT_TYPE.USER_INPUT: {
      return (
        <Tooltip title="User input">
          <Badge badgeContent="" color="primary" />
        </Tooltip>
      );
    }
    case OPERATION_DETAILS_EVENT_TYPE.VOICE_APP_RESPONSE: {
      return (
        <Tooltip title="Voice application response ">
          <Badge badgeContent="" color="secondary" />
        </Tooltip>
      );
    }
    case OPERATION_DETAILS_EVENT_TYPE.SPECIAL_EVENT: {
      return (
        <Tooltip title="System information">
          <Badge badgeContent="" color="info" />
        </Tooltip>
      );
    }
    default: {
      nortadaLogger.error(`${type} is not defined`);
      return null;
    }
  }
};

export default StatusIcon;
